import axios from 'axios';
import { message } from 'antd';
import NodeRSA from 'node-rsa';
import store from 'store';

export default {
  state: {
    visible: false,
  },
  reducers: {
    setVisible(state, visible = true) {
      return { ...state, visible };
    },
  },
  effects: (dispatch) => ({
    preLogin(params) {
      // fetchPublicKey
      return axios.get(`/oauth/sys/loginPre?username=${params.username}`).then((res) => {
        if (res.error) {
          message.error(res.msg);
          return Promise.reject(res);
        }
        const key = new NodeRSA(res.data, 'public', { encryptionScheme: 'pkcs1' });
        const encrypt1 = key.encrypt(params.password, 'base64');
        // const password = encrypt1.replace(/\//g, '_').replace(/\+/g, '-');
        const username = params.username.trim();
        return this.userLogin({ username, password: encrypt1, mallType: params.mallType });
      });
    },
    userLogin(params, rootState) {
      return axios.post('/oauth/sys/loginMall', params).then((res) => {
        if (res.success) {
          dispatch.user.setToken(res.data.access_token);
          if (rootState.login.visible) {
            this.setVisible(false);
          }
          return dispatch.user.fetchAllInfo();
        }
        message.error(res.msg);
        return Promise.reject(res);
      });
    },
    logout() {
      store.clearAll();
      dispatch.user.reset();
    },
  }),
};
